import axios from "@/services/axios.config";
import type { CreditRetirementListWithPagination } from "@/types/creditTracking";
import { toastOnError } from "@/utils/toastOnError";
import { useQuery } from "@tanstack/react-query";

const fetchCreditRetirementListForRegistry = async (
	limit: number,
	offset: number,
): Promise<CreditRetirementListWithPagination> =>
	axios
		.get<APIResponse<CreditRetirementListWithPagination>>("/credit/retire/list/public", {
			params: { limit, offset },
		})
		.then((res) => res.data.data ?? { limit: String(limit), offset: String(offset), count: 0, data: [] })
		.catch((err) => Promise.reject(err.response?.data as APIResponse));

export default function useGetCreditRetirementListForRegistry(limit: number, offset: number) {
	return useQuery({
		queryKey: ["getCreditRetirementListForRegistry", limit, offset],
		queryFn: () => fetchCreditRetirementListForRegistry(limit, offset),
		onError: (err: APIResponse) => {
			if (![400, 403, 404].includes(err.httpStatus)) {
				toastOnError(err);
			}
		},
	});
}
